import { ApiGroup } from "../types/ApiTypes"

export const GiftishowApi: ApiGroup = {
    GetGoodsList: {
        title: "외부 기프티쇼 상품 목록 조회",
        method: "GET",
        url: "/Giftishow/Goods",
        paramz: {}, //{ start, size, keyword }
    },
    GetGoodsDetail: {
        title: "외부 기프티쇼 상품 상세 조회",
        method: "GET",
        url: "/Giftishow/Goods/:goodsCode",
        pathParams: ["goodsCode"],
        paramz: {},
    },
    GetBizMoney: {
        title: "비즈머니 잔액 조회",
        method: "GET",
        url: "/Giftishow/BizMoney",
        paramz: {},
    },
    SendCoupon: {
        title: "쿠폰 발송",
        method: "POST",
        url: "/Giftishow/Send",
        paramz: {},
    },
    CancelCoupon: {
        title: "쿠폰 취소",
        method: "POST",
        url: "/Giftishow/Cancel",
        paramz: {},
    },
    GetDisplayList: {
        title: "전시 상품 목록 조회",
        method: "GET",
        url: "/Giftishow/DisplayList",
        paramz: {}, //{ start, size }
    },
    AddDisplayItem: {
        title: "전시 상품 추가",
        method: "POST",
        url: "/Giftishow/DisplayList",
        paramz: {}, // { goodsCode, categorySeqId }
    },
    UpdateDisplayItem: {
        title: "전시 상품 수정",
        method: "PUT",
        url: "/Giftishow/DisplayList/:displaySeq",
        pathParams: ["displaySeq"],
        paramz: {}, // { categorySeqId }
    },
    UpdateDisplayOrder: {
        title: "전시 상품 순서 변경",
        method: "PUT",
        url: "/Giftishow/DisplayList/Order",
        paramz: {}, // List<DisplayOrderUpdateDto>
    },
    DeleteDisplayItem: {
        title: "전시 상품 삭제",
        method: "DELETE",
        url: "/Giftishow/DisplayList/:displaySeq",
        pathParams: ["displaySeq"],
        paramz: {},
    },
    SyncOrders: {
        title: "주문 상태 동기화",
        method: "POST",
        url: "/Giftishow/SyncOrders",
        paramz: {},
    }
}
